import { useForm } from 'react-hook-form';
import useUser from '../../api/hooks/useUser';
import { settingsInputs } from '../../consts/inputs';
import { toIcons } from '../../consts/Paths';
import MainContext from '../../context/MainContext';
import useIsMobile from '../../hooks/useIsMobile';
import { getDefaultValue } from '../../utils/getMethods';
import CustomInput from '../inputs/CustomInput';
import { useContext, useEffect, useState } from 'react';
import useUpdatePassord from '../../api/hooks/password/useUpdatePassword';
import { validatePassword } from '../../utils/validations';
import useLogMessage from '../../hooks/useLogMessage';
import { logMsgBgColors } from '../../consts/misc';
import LogMessage from '../misc/LogMessage';
import { userRemappingFromResult } from '../../utils/userRemapping';
import { apiURL } from '../../consts/URLs';
import { USERS } from '../../api/endpointList';

const SettingsEditProfileModal = (props: any) => {
    const { user, setUser, userTreated, setUserTreated, token } = useContext(MainContext);
    // const { RESPONSES, RESULTS, CTAs } = useUser(token);
    const { updatePasswordResponse, updatePasswordResult, updatePassword } = useUpdatePassord(token);
    const logMessageEdit = useLogMessage();
    const { write } = props.logMessage;
    const { isMobile } = useIsMobile();
    const editUserProfileForm = useForm();

    const [objToUpdate, setObjToUpdate] = useState<any>();

    const onSubmit = async (data: any) => {
        try {
            const queryParams = new URLSearchParams();

            if (data.name && data.name !== user?.name) {
                queryParams.append('name', data.name);
            }
            if (data.email && data.email !== user?.email) {
                queryParams.append('email', data.email);
            }
            if (data.password && data.passwrd !== user?.password) {
                queryParams.append('password', data.password);
            }

            const url = `${apiURL}/${USERS}/me?${queryParams.toString()}`;
            const header = {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-type': 'application/json; charset=UTF-8',
                },
            };

            const response = await fetch(url, header);

            if (response.ok) {
                const json = await response.json();

                console.log(json);

                if (data.name && data.name !== user?.name) {
                    setUser((current) => ({
                        ...current,
                        name: data.name,
                    }));
                }
                if (data.email && data.email !== user?.email) {
                    setUser((current) => ({
                        ...current,
                        name: data.email,
                    }));
                }
                if (data.password && data.passwrd !== user?.password) {
                    setUser((current) => ({
                        ...current,
                        name: data.password,
                    }));
                }
            }
        } catch (e) {
            console.error(e);
        }
        // const obj = {
        //     name: data.name,
        //     email: data.email,
        //     password: data.password,
        // };
        // updatePassword(data);
        // if (props.isMainUser) {
        //     if (user && data.password === '' && data.password_confirmation === '') {
        //         /*
        // console.log("main user and not changing password");
        // console.log(obj, user?.id); */
        //         CTAs.updateUser(obj, user?.id);
        //     } else if (data.password !== '' || data.password_confirmation !== '') {
        //         /*
        // console.log("main user and changing password");
        // console.log(obj, user?.id, data.password, data.password_confirmation); */
        //         changePWandUpdateUser(data.password, data.password_confirmation, obj);
        //     }
        // } else if (userTreated && !props.isMainUser) {
        //     /*  console.log("not main user and not changing password");*/
        //     /* console.log(obj, userTreated?.id); */
        //     CTAs.updateUser(obj, userTreated?.id);
        // }
    };

    // useEffect(() => {
    //     /* console.log(RESPONSES.updateUserResponse, RESULTS.updateUserResult);   */
    //     if (RESPONSES.updateUserResponse?.ok) {
    //         write('subject', `User `);
    //         write('other_text', `updated `);
    //         write('complement', `Successfully!`);
    //         write('bgColor', logMsgBgColors.correct);
    //         props.toggler.setIsToggled(false);
    //         const remappedUser = userRemappingFromResult(RESULTS.updateUserResult.user);
    //         if (props.isMainUser) {
    //             setUser(remappedUser);
    //         } else setUserTreated(remappedUser);
    //     } else if (RESPONSES.updateUserResponse?.ok === false) {
    //         logMessageEdit.write('subject', `${RESPONSES.updateUserResponse?.status}: `);
    //         logMessageEdit.write('other_text', RESPONSES.updateUserResponse?.statusText);
    //         logMessageEdit.write('bgColor', logMsgBgColors.error);
    //     }
    // }, [RESPONSES.updateUserResponse]);

    useEffect(() => {
        console.log(updatePasswordResponse, updatePasswordResult);
        if (updatePasswordResponse?.ok) {
            logMessageEdit.write('subject', 'Password ');
            logMessageEdit.write('other_text', `updated `);
            logMessageEdit.write('complement', `Successfully!`);
            logMessageEdit.write('bgColor', logMsgBgColors.correct);
            // if (user) {
            //     setTimeout(() => {
            //         CTAs.updateUser(objToUpdate, user?.id);
            //     }, 2000);
            // }
        } else if (updatePasswordResponse?.ok === false) {
            logMessageEdit.write('subject', updatePasswordResponse?.status);
            logMessageEdit.write('bgColor', logMsgBgColors.error);
        }
    }, [updatePasswordResponse]);

    return (
        <div
            className='modal-wrapper'
            style={{
                height: `100vh`,
            }}
        >
            <div
                className='settings-edit-modal'
                style={{
                    width: isMobile ? '345px' : '',
                }}
            >
                <form onSubmit={editUserProfileForm.handleSubmit(onSubmit)} autoComplete='off'>
                    <div className='settings-edit-modal-content'>
                        <div className='modal-header'>
                            <p className='modal-title'>Edit your data</p>
                            <div className='Oval' onClick={props.toggler.toggle}>
                                <img src={`${toIcons}/close.svg`} />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '25px',
                                marginTop: '22px',
                            }}
                        >
                            <CustomInput width={'100%'} title={'Nome'} name={'name'} type={'text'} register={editUserProfileForm.register} errors={editUserProfileForm.formState.errors} />
                            <CustomInput width={'100%'} title={'Email'} name={'email'} type={'text'} register={editUserProfileForm.register} errors={editUserProfileForm.formState.errors} />
                            <CustomInput width={'100%'} title={'Password'} name={'password'} type={'password'} register={editUserProfileForm.register} errors={editUserProfileForm.formState.errors} />
                        </div>
                        <button
                            style={{
                                marginTop: '44px',
                                marginRight: '0',
                                width: isMobile ? '100%' : '105px',
                            }}
                            className='modal-button'
                            type='submit'
                        >
                            <p className='modal-button-text'>Save</p>
                        </button>
                    </div>
                </form>
            </div>
            {logMessageEdit.isToggled && (
                <LogMessage
                    text={{
                        subject: logMessageEdit.message.subject,
                        other_text: logMessageEdit.message.other_text,
                        complement: logMessageEdit.message.complement,
                    }}
                    bgColor={logMessageEdit.message.bgColor}
                    /* shifted */
                />
            )}
        </div>
    );
};
export default SettingsEditProfileModal;
